import { DefaultTheme } from 'styled-components';

export const theme: DefaultTheme = {
  new: {
    color: {
      shade: {
        1: '#ffffff',
        2: '#222222',
        3: '#000000',
      },

      neutral: {
        0: '#fbfbfb',
        1: '#fdfdfd',
        2: '#f7f7f7',
        3: '#ebebeb',
        4: '#dddddd',
        5: '#d3d3d3',
        6: '#c2c2c2',
        7: '#b0b0b0',
        8: '#717171',
        9: '#5e5e5e',
      },

      primary: {
        1: '#d51a39',
        2: '#aa152e',
      },

      brand: {
        1: {
          // red
          normal: '#ff7262',
          dark: '#f04c58',
          darker: '#a6333c',
        },

        2: {
          // green
          normal: '#76ce82',
          dark: '#399a6f',
          darker: '#2a7051',
        },

        3: {
          // blue
          normal: '#0a9ecc',
          dark: '#0362a6',
          darker: '#025088',
        },
        4: {
          // purple
          normal: '',
          dark: '#5942E3',
          darker: '',
        },
        5: {
          // orange
          normal: '',
          dark: '#C25700',
          darker: '',
        },
      },

      error: {
        1: '#fef8f6',
        2: '#c13515',
      },

      accent: {
        1: '#ffedf2',
        2: '#ffc700',
        3: '#ddeb6a',
      },

      program: {
        1: '#0a9ecc',
        2: '#0362a6',
        3: '#ff7262',
        4: '#a259ff',
        5: '#ffc700',
      },
    },

    type: {
      face: '"Poppins", "Lucida Grande", "Tahoma", sans-serif',

      size: {
        12: '0.75rem',
        14: '0.875rem',
        16: '1rem',
        18: '1.125rem',
        20: '1.25rem',
        22: '1.375rem',
        24: '1.5rem',
        26: '1.625rem',
        28: '1.75rem',
        32: '2rem',
        34: '2.125rem',
        38: '2.375rem',
        42: '2.625rem',
        48: '3rem',
        54: '3.375rem',
        96: '6rem',
      },

      weight: {
        light: 200,
        regular: 300,
        medium: 400,
        semibold: 500,
        bold: 600,
      },
    },

    breakpoint: {
      tabletSmall: {
        only: 'screen and (max-width: 63.9375rem)', // Tablet small only
        down: 'screen and (max-width: 63.9375rem)', // Tablet small and smaller
        min: '0',
        max: '63.9375rem', // 1023px
      },

      tabletLarge: {
        only: 'screen and (min-width: 64rem) and (max-width: 89.9375rem)', // Tablet large only
        up: 'screen and (min-width: 64rem)', // Tablet large and larger
        down: 'screen and (max-width: 89.9375rem)', // Tablet large and smaller
        min: '64rem', // 1024px
        max: '89.9375rem', // 1439px
      },

      desktopSmall: {
        only: 'screen and (min-width: 90rem) and (max-width: 119.9375rem)', // Desktop small only
        up: 'screen and (min-width: 90rem)', // Desktop small and larger
        down: 'screen and (max-width: 119.9375rem)', // Desktop small and smaller
        min: '90rem', // 1440px
        max: '118.0625rem', // 1890px (1919px accounting for scrollbar)
      },

      desktopLarge: {
        only: 'screen and (min-width: 120rem)', // Desktop large only
        up: 'screen and (min-width: 120rem)', // Desktop large and larger
        min: '118.125rem', // 1890px (1920px accounting for scrollbar)
      },
    },
  },

  // LEGACY THEME STARTING HERE
  color: {
    // Red
    primary: {
      light: '#f94c58',
      regular: '#d51a39',
      dark: '#a5131f',
    },
    // Blue
    secondary: {
      extraLight: '#e7f2f5',
      light: '#0a9ecc',
      regular: '#0362a6',
    },
    // Green
    tertiary: {
      extraLight: '#eef5ee',
      light: '#76ce82',
      regular: '#399a6f',
    },
    // Gray
    grayscale: {
      1000: '#fff',
      900: '#fbfbfb',
      800: '#f0f1f2',
      700: '#e5e5e5',
      600: '#bbbcc2',
      400: '#a6a7b0',
      200: '#90939d',
      100: '#5e5e5e',
      0: '#262a41',
      black: '#000',
    },
    // Yellow
    accentPrimary: {
      light: '#ffea6a',
      regular: '#ffc700',
    },
    // Purple
    accentSecondary: {
      regular: '#a259ff',
    },
    // Orange
    accentTertiary: {
      regular: '#ff7262',
    },
  },
  type: {
    face: '"Lato", "Lucida Grande", "Tahoma", sans-serif',
    size: {
      max: '2.25rem',
      huge: '2rem',
      larger: '1.5rem',
      large: '1.25rem',
      regular: '1rem',
      small: '0.875rem',
      tiny: '0.75rem',
      atomic: '0.625rem',
    },
    weight: {
      regular: 400,
      bold: 700,
      black: 900,
    },
  },
  shadow: {
    regular: '0 6px 12px rgba(44, 147, 184, 0.07)',
    active: '0 6px 6px rgba(44, 147, 184, 0.07)',
    hover: '0 6px 18px rgba(44, 147, 184, 0.07)',
    dialog: '0 4px 12px #efefef',
  },
};
